"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const CanceledRequestError_1 = __importDefault(require("./errors/CanceledRequestError"));
const definitions_1 = require("./errors/definitions");
const NetworkRestError_1 = __importDefault(require("./errors/NetworkRestError"));
/** Plain http post and get requests
 * They can be either intercepted or not
 */
class HTTP {
    constructor(...args) {
        if (args.length === 0) {
            // console.log('Used constructor 1');
            this.axiosInstance = axios_1.default;
            return;
        }
        if (args.length === 2) {
            // console.log('Used constructor 2');
            const [interceptRequest, interceptResponse] = args;
            this.axiosInstance = this.interceptAxiosInstance(interceptRequest, interceptResponse);
            return;
        }
        throw new Error('Undefined constructor.');
    }
    async handler(config) {
        try {
            const response = await this.axiosInstance(config);
            return { data: response, error: null };
        }
        catch (error) {
            if (axios_1.default.isAxiosError(error)) {
                return { data: null, error: this.handleAxiosError(error) };
            }
            return { data: null, error };
        }
    }
    async handlerWithoutRetries(config) {
        try {
            const response = await (0, axios_1.default)(config);
            return { data: response, error: null };
        }
        catch (error) {
            if (axios_1.default.isAxiosError(error)) {
                return { data: null, error: this.handleAxiosError(error) };
            }
            return { data: null, error };
        }
    }
    /** [1] https://thedutchlab.com/blog/using-axios-interceptors-for-refreshing-your-api-token
     *  [2] https://www.npmjs.com/package/axios#interceptors
     */
    interceptAxiosInstance(interceptRequest, interceptResponse) {
        const instance = axios_1.default.create();
        // Request interceptor for API calls
        instance.interceptors.request.use(interceptRequest, (error) => {
            // Do something with request error
            Promise.reject(error);
        });
        // Allow to intercept response error
        instance.interceptors.response.use((response) => response, async (error) => {
            const originalRequest = error.config;
            const needToRetryRequest = await interceptResponse(error);
            if (needToRetryRequest) {
                originalRequest.retry = true;
                return instance.request(originalRequest);
            }
            return Promise.reject(error);
        });
        return instance;
    }
    handleAxiosError(error) {
        if (!error.response) {
            // Handle canceled requests from axios interceptors
            if (error.message === definitions_1.CANCEL_REQUEST_MSG)
                return new CanceledRequestError_1.default(error.message);
            // console.error('AxiosError', error.message, ':AND:', error);
            // network error - also !error.status
            return new NetworkRestError_1.default(error.message);
        }
        // http status code
        const code = error.response.status;
        // response data
        const response = error.response.data;
        return error.response;
    }
}
exports.default = HTTP;
//# sourceMappingURL=index.js.map